import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import * as EventActions from './event.actions';
import { EventService } from '../services/event.service';
import { CalendarEventDto } from '@shared/dto';

@Injectable()
export class EventEffects {
  private readonly actions$ = inject(Actions);
  private readonly eventService = inject(EventService);

  readEvents$ = createEffect(() => this.actions$.pipe(
    ofType(EventActions.readEvents),
    switchMap(({ start, end }) => this.eventService.readCalendar(start, end).pipe(
      map((data: CalendarEventDto[]) => EventActions.readEventsSuccess({ data })),
      catchError((error) => of(EventActions.readEventsFailure({ error }))),
    )),
  ));

  readAgenda$ = createEffect(() => this.actions$.pipe(
    ofType(EventActions.readAgenda),
    switchMap(({ start, end }) => this.eventService.readCalendar(start, end).pipe(
      map((data: CalendarEventDto[]) => EventActions.readAgendaSuccess({ data })),
      catchError((error) => of(EventActions.readAgendaFailure({ error }))),
    )),
  ));
}
